import { match } from 'ts-pattern';
import { BaseMapper, Nullable } from '@ps/utils';
import {
  ManagedUserDto,
  ManagedUserProjectManagerDto,
} from '../dtos/managed-user.dto';
import {
  ManagedUser,
  ManagedUserProjectManager,
  ManagedUserStatus,
} from '../../models/managed-user.model';
import {
  toBuyerAccessLevel,
  toOperatorAccessLevel,
  toSupplierAccessLevel,
} from './access-level.parser';

export class ManagedUserMapper extends BaseMapper<ManagedUserDto, ManagedUser> {
  public fromDto(dto: ManagedUserDto): ManagedUser {
    return {
      id: dto.id,
      name: dto.name,
      email: dto.email,
      companyId: dto.company,
      companyName: dto.companyName ?? '',
      status: this._status(dto.status),
      buyerAccessLevel: toBuyerAccessLevel(dto.buyerSideAccessLevels),
      supplierAccessLevel: toSupplierAccessLevel(dto.supplierSideAccessLevels),
      operatorAccessLevel: toOperatorAccessLevel(dto.operatorAccessLevels),
      isApiUser: dto.isApiUser,
      isMultiBuyerManager: !!dto.isMBManager,
      accessLevelLabel: dto.accessLevel ?? '',
      slackMemberId: dto.slackMemberId ?? '',
      hasQuestionLibraryAccess: !!dto.questionLibraryAccessLevel,
      primaryEntityId: this._primaryEntityId(dto.primary_entity_id),
      defaultProjectManager: this._projectManager(dto.proxyProjectManager),
    };
  }

  /** `Paused` collapses into `Deactive`, as legacy `_verifyUserStatus` does. */
  private _status(status: string): ManagedUserStatus {
    return match(status)
      .with('Active', (): ManagedUserStatus => 'Active')
      .with('Inactive', (): ManagedUserStatus => 'Inactive')
      .otherwise((): ManagedUserStatus => 'Deactive');
  }

  /** The backend writes `0` for "no primary entity". */
  private _primaryEntityId(entityId?: number): Nullable<number> {
    return entityId ? entityId : null;
  }

  private _projectManager(
    dto?: ManagedUserProjectManagerDto,
  ): Nullable<ManagedUserProjectManager> {
    if (!dto?.id) {
      return null;
    }

    return { id: dto.id, name: dto.nm ?? '', email: dto.email ?? '' };
  }
}
